import { Link } from "react-router-dom";
import logo from "@/assets/first-deal-logo.png";

const Footer = () => (
  <footer className="border-t border-border bg-sidebar text-sidebar-foreground">
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {/* Brand */}
        <div className="space-y-4">
          <img src={logo} alt="First Deal" className="h-10 w-auto brightness-200" />
          <p className="text-sm text-sidebar-foreground/60">
            Brandon Turner's 12-month mastermind helping you close your first (or next) real estate deal.
          </p>
        </div>

        {/* Links */}
        <div>
          <h4 className="mb-3 font-serif text-sm font-semibold">Navigate</h4>
          <ul className="space-y-2 text-sm text-sidebar-foreground/60">
            <li><Link to="/" className="hover:text-primary">Free Calculators</Link></li>
            <li><Link to="/firstdeal" className="hover:text-primary">First Deal Program</Link></li>
            <li><Link to="/apply" className="hover:text-primary">Apply</Link></li>
            <li><Link to="/login" className="hover:text-primary">Member Login</Link></li>
          </ul>
        </div>

        {/* Resources */}
        <div>
          <h4 className="mb-3 font-serif text-sm font-semibold">Free Resources</h4>
          <ul className="space-y-2 text-sm text-sidebar-foreground/60">
            <li><Link to="/tools" className="hover:text-primary">Rental Analyzer</Link></li>
            <li><Link to="/tools" className="hover:text-primary">BRRRR Calculator</Link></li>
            <li><Link to="/tools" className="hover:text-primary">Mortgage Calculator</Link></li>
          </ul>
        </div>

        {/* Social */}
        <div>
          <h4 className="mb-3 font-serif text-sm font-semibold">Connect</h4>
          <ul className="space-y-2 text-sm text-sidebar-foreground/60">
            <li><a href="#" className="hover:text-primary">Instagram</a></li>
            <li><a href="#" className="hover:text-primary">YouTube</a></li>
            <li><a href="#" className="hover:text-primary">BiggerPockets</a></li>
          </ul>
        </div>
      </div>

      <div className="mt-10 border-t border-sidebar-border pt-6 text-center text-xs text-sidebar-foreground/40">
        © {new Date().getFullYear()} First Deal. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;
